import { Language } from '../types';

export const languages: Language[] = [
    { name: 'Arabic', level: 'Native' },
    { name: 'English', level: 'Professional' },
];
